export default "__VITE_ASSET__DN$vqXQN__"